import { ABOUT_US_PAGE_LINK, WHATS_NEW_PAGE_LINK, BLOG_PAGE_LINK, BUILDERS_CERTIFICATIONS_PAGE_LINK, CUSTOMERS_PAGE_LINK, AI_TRUST_CENTER_SITE_LINK, HELP_CENTER_LINK, SUPPORT_PAGE_LINK, PARTNERS_PAGE_LINK, AI_TEMPLATE_CENTER_AGENT_LINK, TEMPLATE_CENTER_PAGE_LINK, APPS_DEVELOPER_LINK } from "constants/links";
export const LEARN_ITEMS = [
    {
        key: "header.tabs.resources.aboutUs",
        url: ABOUT_US_PAGE_LINK
    },
    {
        key: "header.tabs.resources.whatsNew",
        url: WHATS_NEW_PAGE_LINK
    },
    {
        key: "header.tabs.resources.blog",
        url: BLOG_PAGE_LINK
    },
    {
        key: "header.tabs.resources.getCertified",
        url: BUILDERS_CERTIFICATIONS_PAGE_LINK
    },
    {
        key: "header.tabs.resources.customerStories",
        url: CUSTOMERS_PAGE_LINK
    },
    {
        key: "header.tabs.products.aiTrustCenter",
        url: AI_TRUST_CENTER_SITE_LINK
    }
];
export const SUPPORT_ITEMS = [
    {
        key: "header.tabs.resources.helpCenter",
        url: HELP_CENTER_LINK
    },
    {
        key: "header.tabs.resources.support",
        url: SUPPORT_PAGE_LINK
    },
    {
        key: "header.tabs.resources.partners",
        url: PARTNERS_PAGE_LINK
    }
];
export const BUILD_ITEMS = [
    {
        key: "header.tabs.resources.aiTemplateCenter",
        url: AI_TEMPLATE_CENTER_AGENT_LINK
    },
    {
        key: "header.tabs.resources.solutionTemplates",
        url: TEMPLATE_CENTER_PAGE_LINK
    },
    {
        key: "header.tabs.resources.appDevelopment",
        url: APPS_DEVELOPER_LINK
    }
];
